import * as types from './actionTypes';

// import axios from 'axios';
// import * as config from '../config/config';

export const saveConfig = (conf) => {
    return (dispatch) => {
        dispatch({type: types.SAVE_CONFIG, config: conf})

    }
}


// WEBPACK FOOTER //
// ./src/actions/configActions.js